/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_FromInputs */

const cs_dashboard_period_from = /** @type {(inputs: Dashboard_Period_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od`)
};

const en_dashboard_period_from = /** @type {(inputs: Dashboard_Period_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Dashboard_Period_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_from = /** @type {((inputs?: Dashboard_Period_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_from(inputs)
	return cs_dashboard_period_from(inputs)
});